"use strict";

class SuperPermissionsController {

    constructor($scope, $timeout, $window, Upload,  SSHttpService, SSUtilService, SSDateService, SSAwsService, SSAppService, SSAlertService , SSUserService, SSConfigService, SSConfirmationService, OTPService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;
        self.$window = $window;
        self.Upload = Upload;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;
        self.OTPService = OTPService;

        self.data = SHOWSUITE.data;
        self.role_id = null;
        self.permissions_idz = [];

        // WEB-3847: Platform-specific login restriction, configured per ROLE.
        // Codes must match the server-side LOGIN_PLATFORM_* constants. A role's
        // allowed_platforms NULL/empty (or all ticked) means "no restriction" — every
        // platform is allowed (backward-compatible default). Untick a platform to block
        // the role from it. Enforcement (default role for WEB/native, selected role for
        // Digital Bookings) is handled server-side.
        self.LOGIN_PLATFORMS = [
            {code: 'WEB', label: 'WEB'},
            {code: 'DIGITAL_BOOKINGS', label: 'Digital Bookings'},
            {code: 'SHOWSUITE_APP', label: 'Showsuite Apps (Native)'}
        ];
        // Checkbox model keyed by platform code for the role create/edit modal.
        self.rolePlatformsModel = {WEB: true, DIGITAL_BOOKINGS: true, SHOWSUITE_APP: true};

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        self.permissions = null;
        self.groups = null;
        self.all_group = null;
        self.all_group_text_field = null;
        self.response = null;
        self.roles = null;
        self.role_permissions_data  = {};
        self.grouped_role_permissions_data = {};
        self.grouped_all_permissions_data = {};
        self.showRolePermissionEdit= false;
        self.rolePermissionsIdzEdit = [];
        // Becomes true only after getRolePermission() has successfully loaded the
        // role's CURRENT permissions. The edit baseline (permissions_idz) is seeded
        // from that data, so we must not enter edit mode until it is loaded — see
        // editRolePermissions() and getRolePermission().
        self.rolePermissionsLoaded = false;
        self.permissionsLoadingIndicator = false;
        self.updatePermissionsContainerVar = false;
        self.showAllowedTags = false;

        self.errorMessage = false;
        self.filter_permissions = '';
        self.filter_marker = '';
        self.role_marker = null;
        self.role_is_ss_only = 0;
        self.filter_list_search = '';
        self.filter_list_group = '';
        self.filter_list_marker = '';
        self.filter_list_ss_only = false;
        self.groups_distinct = [];

        self.errTitle = '';
        self.errContent = '';
        self.errCatId = '';
        self.developersList = null;
        self.developer_id = null;
        self.importPermissions = false;
        self.importMode = null;
        self.developerRolePermissionExcelFile = null;
        self.import_developer_id= null;
        // WEB-3506: optional Project (property_id) scope for the matrix export/import.
        self.exportPropertiesList = null;
        self.importPropertiesList = null;
        self.property_id = null;
        self.import_property_id = null;

        // WEB-3085: optional Project (property_id) scope for property-level permissions.
        self.rolePropertiesList = [];
        self.selected_property_id = null;
        self.selected_property_name = null;
        self.property_permission_idz = [];
        self.rolePermissionPropertyIdsMap = {};
        self.copyPropertyPermissionsModal = false;
        self.copy_from_property_id = null;

        self.initRolesFields();
        self.getPermissionsData(true);
        self.getRolesData(null, true);
        self.getRolePermission();
        self.getDeveloperList();
        self.getRoleScopedProperties();
        // self.$timeout(function() { $("select.dashboard-select#group-select").niceSelect('update'); });

    }

    getPermissionsData(clearAlert) {
        let self = this;

        let url = 'sec/super/users/permissions/';
        let params = {
            order_by: 'group__asc,name__asc'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if(clearAlert){
                self.SSAlertService.clear();
            }
            self.response = response.data;
            self.permissions = response.data.permissions;

            self.cleanPermission = self.permissions.filter((permission) => {return permission.group;});
            self.groups_all = self.cleanPermission.map((permission) => permission.group);
            self.groups_all.push('other');
            self.groups = self.groups_all.filter((value, index, self) => self.indexOf(value) === index);
            self.groups_distinct = [...new Set(response.data.permissions.filter(p => p.group).map(p => p.group))].sort();

            // Apply auto-filter (role marker may already be resolved from getRolePermission).
            self.applyMarkerFilter();

            self.$timeout(function() { $("select.permissions-select#group-select").niceSelect('update'); });
        });
    }

    /**
     * WEB-3085: properties list for the "Select Project" dropdown next to the
     * Edit button, and for resolving permission `property_ids` to names.
     * Not developer-scoped — mirrors the Flutter app's AgentsListingFilterWidget
     * "Select Property" dropdown (`properties/customized`).
     */
    getRoleScopedProperties() {
        const self = this;

        self.rolePropertiesList = [];
        let url = 'properties/customized';

        let params = {
            offset: 0,
            limit: 9999,
            property_selected_fields: 'id,name'
        };
        // Narrows the list to the role's developer's properties; roles with no
        // developer_id still get every property.
        if (self.role_id) {
            params.role_id = self.role_id;
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.properties) {
                self.rolePropertiesList = response.data.properties;
            }
            self.$timeout(function() {
                $("select.dashboard-select#role-project-select").niceSelect('update');
                $("select.dashboard-select#copy-property-select").niceSelect('update');
            });
        });
    }

    /**
     * WEB-3085: called when the "Select Project" dropdown (next to Edit) changes.
     * Resolves the display name and re-applies the marker filter so
     * `grouped_all_permissions_data` picks up/hides property-level permissions.
     */
    onProjectChanged() {
        const self = this;
        self.selected_property_name = self.resolvePropertyName(self.selected_property_id);
        self.applyMarkerFilter(self.filter_permissions);
    }

    resolvePropertyName(propertyId) {
        const self = this;
        if (!propertyId || !self.rolePropertiesList) {
            return null;
        }
        let property = self.rolePropertiesList.find(function (p) {
            return String(p.id) === String(propertyId);
        });
        return property ? property.name : null;
    }

    /**
     * WEB-3085: comma-separated property names for a permission's `property_ids`,
     * used for the "Properties" column on the read-only (before-edit) table.
     */
    getPropertyNamesForPermission(permission) {
        const self = this;
        if (!permission || !permission.property_level || !permission.property_ids || !self.rolePropertiesList) {
            return '';
        }
        let ids = String(permission.property_ids).split(',')
            .map(function (id) { return id.trim(); })
            .filter(function (id) { return id !== ''; });
        let names = [];
        $.each(ids, function (index, id) {
            let property = self.rolePropertiesList.find(function (p) { return String(p.id) === id; });
            if (property) {
                names.push(property.name);
            }
        });
        return names.join(', ');
    }

    /**
     * WEB-3085: permission ids (property_level == 1) already granted to the given
     * property for this role. Sourced from `rolePermissionPropertyIdsMap`, which is
     * built from the role-scoped permissions endpoint — the generic all-permissions
     * endpoint does not carry this role's per-property scoping.
     */
    getPropertyLevelPermissionIdsForProperty(propertyId) {
        const self = this;
        let ids = [];
        if (!propertyId) {
            return ids;
        }
        let sourceList = (self.response && self.response.permissions) ? self.response.permissions : self.permissions;
        $.each(sourceList, function (index, permission) {
            if (!permission.property_level) return;
            let propertyIdsCsv = self.rolePermissionPropertyIdsMap[permission.id];
            if (!propertyIdsCsv) return;
            let idList = String(propertyIdsCsv).split(',').map(function (s) { return s.trim(); });
            if (idList.indexOf(String(propertyId)) > -1) {
                ids.push(permission.id);
            }
        });
        return ids;
    }

    /**
     * WEB-3085: opens the "Copy Property Permissions" popup shown next to the
     * selected-Project label on the Edit page.
     */
    openCopyPropertyPermissionsModal() {
        const self = this;
        self.copy_from_property_id = null;
        self.copyPropertyPermissionsModal = true;
        jQuery('#copyPropertyPermissionsModal').modal('show');
        self.$timeout(function() { $("select.dashboard-select#copy-property-select").niceSelect('update'); });
    }

    closeCopyPropertyPermissionsModal() {
        const self = this;
        self.copyPropertyPermissionsModal = false;
        jQuery('#copyPropertyPermissionsModal').modal('hide');
    }

    proceedCopyPropertyPermissions() {
        const self = this;

        if (!self.copy_from_property_id) {
            return;
        }

        let sourcePropertyId = self.copy_from_property_id;
        let sourcePropertyName = self.resolvePropertyName(sourcePropertyId) || '';

        self.closeCopyPropertyPermissionsModal();

        self.SSConfirmationService.getConfirmed(
            'Confirmation',
            'Are you sure you want to copy property level permissions of ' + sourcePropertyName + ', your current selection of property level permissions will be overwritten.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.copyPropertyPermissionsFrom(sourcePropertyId);
            }
        );
    }

    copyPropertyPermissionsFrom(sourcePropertyId) {
        const self = this;
        self.property_permission_idz = self.getPropertyLevelPermissionIdsForProperty(sourcePropertyId);
    }

    getDeveloperUsersList() {
        let self = this;

        let url = 'sec/super/developers/users?fields=email,first_name';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.developersList = response.data.users;
            self.$timeout(function() { $("select.dashboard-select#developer-select").niceSelect('update'); });

        });
    }

    getDeveloperList() {
        let self = this;

        let url = 'developers';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.developersList = response.data.developers;
            self.$timeout(function() { $("select.dashboard-select#developer-select").niceSelect('update'); });

        });
    }

    exportDeveloperRolePermissions(){
        const self = this;

        if (!self.developer_id){
            self.SSAlertService.danger('Error!', 'Please select developer for export');
            return;
        }

        loading(true);

        let url = "sec/super/export/user-roles-permissions?developer_id="+self.developer_id;

        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href = url;

        self.$timeout(function() {
            self.SSAlertService.success('Success!', 'Developer Roles Permission exported successfully.');
            loading(false);
        }, 1000);
    }

    /**
     * WEB-3495: export role-permission data for the selected developer in the new
     * single-sheet "Roles & Permissions Matrix" .xlsx format. Mirrors
     * {@link exportDeveloperRolePermissions} but targets the matrix export route.
     * Gated in the view by the SS_ROLES_PERMISSIONS_MATRIX_EXPORT permission.
     */
    exportDeveloperRolePermissionsMatrix(){
        const self = this;

        if (!self.developer_id){
            self.SSAlertService.danger('Error!', 'Please select developer for export');
            return;
        }

        loading(true);

        let url = "sec/super/export/user-roles-permissions-matrix?developer_id="+self.developer_id;
        // WEB-3506: optional project scope.
        if (self.property_id) {
            url += "&property_id=" + self.property_id;
        }

        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href = url;

        self.$timeout(function() {
            self.SSAlertService.success('Success!', 'Roles & Permissions Matrix exported successfully.');
            loading(false);
        }, 1000);
    }

    filterDeveloperRoleList(){
        const self = this;
        self.getRolesData(self.developer_id, true);
        // WEB-3506: refresh the export Project list for the chosen developer.
        self.loadDeveloperProperties(self.developer_id, 'export');
    }

    /**
     * WEB-3506: when the import developer changes, (re)load that developer's
     * projects for the matrix Project selector and reset the chosen project.
     */
    onImportDeveloperChange(){
        const self = this;
        self.loadDeveloperProperties(self.import_developer_id, 'import');
    }

    /**
     * WEB-3506: load the selected developer's projects for the optional Project
     * (property_id) selector used by the matrix export/import. Scoped server-side
     * via `sec/super/properties?developer_id=`. Resets the chosen project so a
     * stale selection from another developer can never be submitted.
     *
     * @param {number|string|null} developerId the selected developer
     * @param {('export'|'import')} target which selector/list to populate
     */
    loadDeveloperProperties(developerId, target){
        const self = this;

        if (target === 'import') {
            self.import_property_id = null;
            self.importPropertiesList = null;
        } else {
            self.property_id = null;
            self.exportPropertiesList = null;
        }

        if (!developerId) {
            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
            return;
        }

        loading(true);
        self.SSHttpService.getAPIRequest('sec/super/properties?developer_id=' + developerId).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            let list = (response.data && response.data.properties) ? response.data.properties : [];
            if (target === 'import') {
                self.importPropertiesList = list;
            } else {
                self.exportPropertiesList = list;
            }
            self.$timeout(function() { $("select.dashboard-select").niceSelect('update'); });
        });
    }

    validateImportParams() {
        const self = this;

        if (!self.import_developer_id) {
            return;
        }
        if (!self.developerRolePermissionExcelFile) {
            return;
        }

        return true;
    }

    importDeveloperRolePermission() {
        const self = this;

        if (!self.developerRolePermissionExcelFile) {
            return;
        }
        self.SSConfirmationService.getConfirmed(
            "Confirm!",
            "Are you sure you want to import?",
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.uploadDeveloperRolePermissionExcel(self.developerRolePermissionExcelFile);
            }
        );
    }
    uploadDeveloperRolePermissionExcel(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        // WEB-3495: matrix import posts to the matrix route; legacy import unchanged.
        let importUrl = self.importMode === 'matrix'
            ? 'sec/super/import/user-roles-permissions-matrix'
            : 'sec/super/import/user-roles-permissions';

        // WEB-3506: a matrix import can be scoped to a single project (property_id).
        let uploadData = {
            developer_id: self.import_developer_id,
            file_import: file
        };
        if (self.importMode === 'matrix' && self.import_property_id) {
            uploadData.property_id = self.import_property_id;
        }

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL(importUrl),
            method: 'POST',
            data: uploadData,
            withCredentials: true
        }).then(
            function (response) {
                loading(false);
                self.progressUploadingFiles = false;

                response = response.data ? response.data : {};

                if (response.code !== 200) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.developer_id = null;
                self.getPermissionsData(false);
                self.getRolesData(null, false);
                self.importPermissions = false;
                self.showImportResult(response);
                self.$timeout(function() { $("select.dashboard-select#developer-select").niceSelect('update'); });

            }, function (response) {
                loading(false);
                self.progressUploadingFiles = false;
                self.SSAlertService.parseAndDisplayError(response);

            }, function (evt) {
            }
        );
    }

    /**
     * WEB-3848: report the real outcome of a role/permission import.
     *
     * Previously the success handler always showed a fixed "imported successfully"
     * toast — so a matrix import that changed nothing (e.g. every edited permission
     * was property-level and no Project was selected, which the server skips) looked
     * identical to a successful one. The server now returns a human-readable
     * `message` plus a structured `data` block ({@link roles_created},
     * {@link roles_touched}, {@link grants_added}, {@link grants_revoked},
     * {@link warnings}); this surfaces the server message and downgrades a no-op or a
     * warning-carrying import from a green "success" to a visible "warning" so the
     * operator is never misled.
     *
     * @param {{message?: string, data?: {roles_created?: number, roles_touched?: number,
     *          grants_added?: number, grants_revoked?: number, warnings?: string[]}}} response
     *        the parsed API response body (already unwrapped from the HTTP envelope)
     * @return {void}
     */
    showImportResult(response){
        const self = this;

        const isMatrix = self.importMode === 'matrix';
        const fallback = (isMatrix ? 'Roles & Permissions Matrix' : 'Developer Roles Permission') + ' imported successfully.';
        const message = (response && response.message) ? response.message : fallback;

        // The legacy 3-sheet import returns no structured counts — keep its behaviour.
        if (!isMatrix) {
            self.SSAlertService.success('Success!', message);
            return;
        }

        const result = (response && response.data) ? response.data : {};
        const warnings = angular.isArray(result.warnings) ? result.warnings : [];
        const netChanges = (parseInt(result.roles_created, 10) || 0)
            + (parseInt(result.roles_touched, 10) || 0)
            + (parseInt(result.grants_added, 10) || 0)
            + (parseInt(result.grants_revoked, 10) || 0);

        if (netChanges === 0) {
            // Nothing was written — the exact case this ticket was raised for.
            self.SSAlertService.warning('No Changes Applied', message);
        } else if (warnings.length) {
            // Some changes applied, but part of the file was skipped (e.g. property-level
            // permissions with no Project selected). Make the caveat visible.
            self.SSAlertService.warning('Imported with Warnings', message);
        } else {
            self.SSAlertService.success('Success!', message);
        }
    }

    importRolePermissionActive(){
        let self = this;
        self.SSAlertService.clear();
        self.importMode = 'legacy';
        self.import_property_id = null;
        self.importPropertiesList = null;
        self.importPermissions = true;
        self.$timeout(function() { $("select.dashboard-select#developer-select").niceSelect('update'); });
    }

    /**
     * WEB-3495: open the import form in "matrix" mode so the upload posts to the
     * matrix import route. Reuses the same form/flow as the legacy import.
     * Gated in the view by the SS_ROLES_PERMISSIONS_MATRIX_IMPORT permission.
     */
    importMatrixRolePermissionActive(){
        let self = this;
        self.SSAlertService.clear();
        self.importMode = 'matrix';
        self.import_property_id = null;
        self.importPropertiesList = null;
        self.importPermissions = true;
        self.$timeout(function() { $("select.dashboard-select#developer-select").niceSelect('update'); });
    }

    goBack(){
        let self = this;
        self.SSAlertService.clear();
        self.importPermissions = false;
        self.importMode = null;
        self.developerRolePermissionExcelFile = null;
        self.import_developer_id= null;
        self.import_property_id = null;
        self.importPropertiesList = null;
        self.$timeout(function() { $("select.dashboard-select#developer-select").niceSelect('update'); });

    }

    initRolesFields(){
        let self = this;
        if(!self.entry){
            self.entry = {};
        }

        if(!self.entry.name){
            self.entry.name = '';
        }
        if(!self.entry.display_name){
            self.entry.display_name = '';
        }
        if(!self.entry.description){
            self.entry.description = '';
        }
        self.entry.is_showsuite_only = self.entry.is_showsuite_only ? 1 : 0;

        // WEB-3847: hydrate the Allowed Platforms checkboxes from the role record.
        self.initRoleAllowedPlatforms(self.entry.allowed_platforms);
    }

    /**
     * WEB-3847: Populate the role Allowed Platforms checkbox model from a role's
     * stored value.
     *
     * @remarks NULL / empty (null, '' or []) means the role is unrestricted, so every
     * platform checkbox is ticked. A non-empty list allows only the listed platform
     * codes (any platform not listed is blocked for the role).
     *
     * @param {(string|Array|null)} value CSV string or array of platform codes.
     */
    initRoleAllowedPlatforms(value) {
        const self = this;

        let codes = [];
        if (Array.isArray(value)) {
            codes = value.slice();
        } else if (typeof value === 'string' && value.trim() !== '') {
            codes = value.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s; });
        }

        // No codes stored => unrestricted => all platforms allowed.
        const allAllowed = codes.length === 0;

        self.rolePlatformsModel = {};
        self.LOGIN_PLATFORMS.forEach(function (platform) {
            self.rolePlatformsModel[platform.code] = allAllowed || codes.indexOf(platform.code) !== -1;
        });
    }

    /**
     * WEB-3847: Currently-ticked platform codes for the role modal.
     *
     * @returns {Array<string>} selected platform codes.
     */
    collectRoleAllowedPlatforms() {
        const self = this;
        return self.LOGIN_PLATFORMS
            .filter(function (platform) { return self.rolePlatformsModel[platform.code]; })
            .map(function (platform) { return platform.code; });
    }

    /**
     * WEB-3847: true when the current selection restricts the role (at least one
     * platform unticked). Drives the inline warning in the modal.
     *
     * @returns {boolean}
     */
    hasRolePlatformRestriction() {
        const self = this;
        return self.LOGIN_PLATFORMS.some(function (platform) {
            return !self.rolePlatformsModel[platform.code];
        });
    }

    canSeeShowsuiteOnlyRoles(){
        const self = this;
        const user = self.SSUserService.getUser();
        return !!(user && (user.root_account == 1 || self.SSUserService.isSuper()));
    }
    initPermissionsFields(){
        let self = this;

        if(!self.entry){
            self.entry = {};
        }
        if(!self.entry.alias){
            self.entry.alias = '';
        }
        if(!self.entry.name){
            self.entry.name = '';
        }
        if(!self.group_field){
            self.group_field = '';
        }
        if(!self.group_text_field){
            self.group_text_field = '';
        }
        if(!self.entry.group){
            self.entry.group = '';
        }
        if(!self.entry.display_name){
            self.entry.display_name = '';
        }
        if(!self.entry.marker){
            self.entry.marker = '';
        }
        self.entry.is_ss_only = self.entry.is_ss_only ? 1 : 0;
    }
    getRolesData(developerId, clearAlert) {
        let self = this;

        let url = 'sec/super/users/roles/all-roles';
        if (developerId) {
            url = url + "?developer_id=" + developerId;
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (clearAlert) {
                self.SSAlertService.clear();
            }
            self.roles = response.data.roles;
            self.getParentRoles(self.roles);
            // self.getPermissionsData();
        });
    }

    toggleEditContainer(flag) {
        const self = this;

        if(flag == 'permissions'){
            self.initPermissionsFields();
            self.permissionsDetailsModal = true;
            jQuery('#permissionsDetailsModal').modal('show');
        }
        if(flag == 'roles'){
            self.initRolesFields();
            self.rolesDetailsModal = true;
            jQuery('#rolesDetailsModal').modal('show');
        }

    }

    open(entry, flag) {
        const self = this;
        self.getPermissionsData(true)

        if (entry) {
            self.entry = angular.copy(entry);
            self.group_field = entry.group;
            self.group_text_field = '';
        }
        else{
            self.entry = null;
            self.group_field = '';
            self.group_text_field = '';
        }
        self.errorMessage = false;

        self.errTitle = '';
        self.errContent = '';

        self.errName = '';
        self.errDisplay_name = '';
        self.errDescription = '';
        self.errProperty_level = '';
        self.errGroup = '';


        self.toggleEditContainer(flag);
    }

    submitPermission() {
        const self = this;

        if (!self.entry) return false;

        self.errorMessage = false;
        self.updateGroupName();
        if (!self.validatePermission()) return false;

        let url = 'sec/super/users/permissions';
        if(!self.entry.property_level){
            self.entry.property_level = 0;
        }
        if(!self.entry.is_ss_only){
            self.entry.is_ss_only = 0;
        }
        if(!self.entry.marker){
            self.entry.marker = null;
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let entry = response.data.permission;
            if (!self.entry.id) {
                self.permissions.push(entry);
            } else {
                jQuery.each(self.permissions, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            // self.toggleEditContainer('permissions');
            self.permissionsDetailsModal = false;
            jQuery('#permissionsDetailsModal').modal('hide');

            self.SSAlertService.success('Saved successfully.');
        };

        loading(true);
        if (self.entry.id) {
            url += '/' + +self.entry.id;
            self.SSHttpService.putAPIRequest(url, self.entry).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, self.entry).then(handleResponse);
        }
    }

    updateGroupName() {
        const self = this;

        if(self.group_field == '' || self.group_field == ' ')
            self.entry.group = null;

        else if(self.group_field == 'other')
            self.entry.group = self.group_text_field;
        else
            self.entry.group = self.group_field;
    }

    postRole() {
        const self = this;

        if (!self.validateRole()) return;

        // WEB-3847: send the selected platform codes; server collapses a full/empty
        // selection to NULL (unrestricted).
        self.entry.allowed_platforms = self.collectRoleAllowedPlatforms();

        self.errorMessage = false;
        let url = 'sec/super/users/roles/';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Created successfully.');

            let entry = response.data.role;

            if (!self.entry.id) {
                self.roles.push(entry);
            } else {
                jQuery.each(self.roles, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            // self.toggleEditContainer('roles');
            self.rolesDetailsModal = false;
            jQuery('#rolesDetailsModal').modal('hide');
        });
    }

    putRole() {
        const self = this;

        if (!self.validateRole()) return;

        // WEB-3847: send the selected platform codes; server collapses a full/empty
        // selection to NULL (unrestricted).
        self.entry.allowed_platforms = self.collectRoleAllowedPlatforms();

        self.errorMessage = false;
        let url = 'sec/super/users/roles/'+self.entry.id;

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Created successfully.');

            let entry = response.data.role;

            if (!self.entry.id) {
                self.roles.push(entry);
            } else {
                jQuery.each(self.roles, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            // self.toggleEditContainer('roles');
            self.rolesDetailsModal = false;
            jQuery('#rolesDetailsModal').modal('hide');
        });
    }

    validateRole() {
        const self = this;

        let error = false;
        let re = /^[a-zA-Z0-9_]+$/;;
        self.errTitle = '';
        self.errContent = '';
        self.errDescription ='';
        self.errPlatforms = '';
        // WEB-3847: at least one platform must remain allowed. Blocking every platform
        // would make the role unusable, and server-side an empty set means "unrestricted"
        // (the opposite of the user's likely intent), so guard against it here.
        if (self.collectRoleAllowedPlatforms().length === 0) {
            self.errPlatforms = 'At least one platform must be allowed.';
            error = true;
        }
        if (!self.entry.name) {
            self.errTitle = 'Code is required';
            error = true;
        }
        if (!self.entry.display_name) {
            self.errContent = 'Display Name is required';
            error = true;
        }

        // Server requires a description on role create/update (412 otherwise); enforce
        // it client-side so the * on the field is honoured and users skip the round-trip.
        if (!self.entry.description || !self.entry.description.trim()) {
            self.errDescription = 'Description is required';
            error = true;
        } else if (self.entry.description.length > 255) {
            self.errDescription = 'Description is maximum 255 characters';
            error = true;
        }

        if (self.entry.name !='' && !re.test(self.entry.name)) {
            self.errTitle = 'Only alphabets, numbers and underscore are allowed';
            error = true;
        }

        return !error;
    }

    validatePermission() {
        const self = this;

        let error = false;
        let re = /^[a-zA-Z0-9_]+$/;;
        self.errName = '';
        self.errDisplay_name = '';
        self.errDiscription = '';

        if (!self.entry.name) {
            self.errName = 'Name title is required';
            error = true;
        }
        if (!self.entry.display_name) {
            self.errDisplay_name = 'Display Name is required';
            error = true;
        }

        if (!self.entry.description) {
            self.description = ' ';
        }
        if (self.entry.description && self.entry.description.length > 255) {
            self.errDescription = 'Description is maximum 255 characters';
            error = true;
        }

        if (self.entry.name !='' && !re.test(self.entry.name)) {
            self.errName = 'Only alphabets, numbers and underscore are allowed';
            error = true;
        }

        return !error;
    }

    removeRole(entry) {
        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this role?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/super/users/roles/' + entry.id;
                let params = {
                    id: entry.id
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    jQuery.each(self.roles, function (i, e) {
                        if (e.id == entry.id) {
                            self.roles.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Removed successfully.');
                });
            }
        );
    }

    removePermissions(entry) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this permission?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let url = 'sec/super/users/permissions/' + entry.id;
                let params = {
                    id: entry.id
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    jQuery.each(self.permissions, function (i, e) {
                        if (e.id == entry.id) {
                            self.permissions.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Removed successfully.');
                });
            }
        );
    }

    getRolePermission(){
        const self = this;
        self.role_id = self.data.role_id?self.data.role_id:null;
        self.role_permissions_data = {};
        self.grouped_role_permissions_data = {};
        // Reset until the role's current permissions have been (re)loaded. Guards
        // editRolePermissions() from seeding an empty edit baseline mid-load.
        self.rolePermissionsLoaded = false;

        let url = 'sec/super/users/roles/'+self.role_id+'/permissions';
        let params = {
            id: self.role_id
        };

        if(self.role_id){
            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.role_permissions_data = {
                    role_permissions : response.data.role_permissions,
                    role : response.data.role,
                };
                // Current permissions are now loaded; editing may seed its baseline safely.
                self.rolePermissionsLoaded = true;

                const role = response.data.role;
                self.role_marker = role ? (role.marker || self.detectRoleMarker(role.name)) : null;
                self.role_is_ss_only = role ? (role.is_showsuite_only || 0) : 0;

                // WEB-3085: role-scoped property_ids per permission. The generic
                // all-permissions endpoint (getPermissionsData) does not carry this
                // role's per-property grants, so this map is the source of truth for
                // seeding/copying property-level permission selections.
                self.rolePermissionPropertyIdsMap = {};
                $.each(self.role_permissions_data.role_permissions, function (index, permission) {
                    if (permission.property_level) {
                        self.rolePermissionPropertyIdsMap[permission.id] = permission.property_ids;
                    }
                });

                for(var i in self.role_permissions_data.role_permissions)
                {
                    self.grouped_role_permissions_data.hasOwnProperty(self.role_permissions_data.role_permissions[i].group) ?
                        self.grouped_role_permissions_data[self.role_permissions_data.role_permissions[i].group].push(self.role_permissions_data.role_permissions[i]) :
                        (self.grouped_role_permissions_data[self.role_permissions_data.role_permissions[i].group] = [self.role_permissions_data.role_permissions[i]]);
                }

                // Re-apply auto-filter if permissions were loaded before the role resolved.
                if (self.response && self.response.permissions) {
                    self.applyMarkerFilter();
                }
            });
        }
    }

    addRemovePermissions(entry, chk){
        const self = this;

        chk = event.target.checked;

        if(chk){
            if(self.permissions_idz.indexOf(entry) == -1)
                self.permissions_idz.push(entry);
        }
        if(!chk){
            if(self.permissions_idz.indexOf(entry) > -1)
                self.permissions_idz.splice($.inArray(entry, self.permissions_idz),1);
        }
    }

    /**
     * WEB-3085: individual-checkbox handler for property-level permissions —
     * tracked in property_permission_idz, separate from permissions_idz.
     */
    addRemovePropertyPermission(entryId){
        const self = this;
        self.setPropertyPermissionChecked(entryId, event.target.checked);
    }

    setPropertyPermissionChecked(id, checked){
        const self = this;
        let idx = self.property_permission_idz.indexOf(id);
        if (checked) {
            if (idx === -1) self.property_permission_idz.push(id);
        } else {
            if (idx > -1) self.property_permission_idz.splice(idx, 1);
        }
    }

    editRolePermissions() {
        const self = this;

        // Guard against a destructive race: permissions_idz is the baseline of
        // CURRENTLY-assigned permissions, seeded from role_permissions_data below
        // and sent verbatim on save (the server does a full replace). If the user
        // opens Edit/Add before getRolePermission() has loaded that data,
        // role_permissions_data.role_permissions is undefined, $.each() iterates
        // nothing, and the baseline is empty — so saving a single newly-checked
        // permission would silently wipe every permission the role already had.
        // Block edit entry until the current permissions are loaded.
        if (!self.rolePermissionsLoaded) {
            self.SSAlertService.danger('Please wait', 'Role permissions are still loading. Please try again in a moment.');
            return;
        }

        self.permissions_idz = [];

        // WEB-3085: global permissions only — property-level ones are tracked in
        // property_permission_idz and sent via property_permission_ids.
        $.each(self.role_permissions_data.role_permissions, function () {
            if (!this.property_level) {
                self.permissions_idz.push(this.id);
            }
        });

        // WEB-3085: seed property-level permission selections for the currently
        // selected Project, kept separate from permissions_idz (see parentCheked/
        // addRemovePropertyPermission/updateRolePermissions).
        self.property_permission_idz = self.getPropertyLevelPermissionIdsForProperty(self.selected_property_id);

        self.showRolePermissionEdit = true;

        $.each(self.grouped_all_permissions_data, function (group, permissions) {

            let isPartial = true;
            let counter = 0;

            $(permissions).each(function(index, permission){
                let isChecked = permission.property_level
                    ? (self.property_permission_idz.indexOf(permission.id) > -1)
                    : self.findValueInArray(permission.id,self.permissions_idz);
                if(isChecked)
                {
                    counter += 1;
                }
            });

            if(counter == permissions['length'])
            {
                isPartial = false;
            }
            else if (counter == 0){

                isPartial = false;
            }

            if (isPartial) {
                self.showChangeset(group);
            }

        });
    }

    cancelEditRolePermission(){

        const self = this;
        self.showRolePermissionEdit = false;
        self.$timeout(function() {
            $("select.dashboard-select#role-project-select").niceSelect('update');
            $("select.dashboard-select#copy-property-select").niceSelect('update');
        });
    }

    updateRolePermissions(){
        const self = this;

        let confirmMsg = 'update';
        if(self.role_permissions_data.role_permissions && self.role_permissions_data.role_permissions.length == 0){
            confirmMsg = 'add'
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to '+ confirmMsg +' permission(s)?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let permissions = [];

                if(self.permissions_idz && self.permissions_idz.length > 0){
                    $.each(self.permissions_idz, function(index, id){
                        if(permissions.indexOf(id) == -1){
                            permissions.push(id);
                        }
                    });
                }

                // WEB-3085: permission_idz carries global permissions only. Property-level
                // selections go in property_id/property_permission_ids below; the
                // server ignores property-level ids in permission_idz (API #1838).

                //let url = 'sec/developer/roles/' + self.current_role.id;
                let url = 'sec/super/users/roles/'+self.role_id+'/update-permission-role';
                self.current_role = self.role_permissions_data.role;
                //if(permissions.length > 1){
                    permissions = permissions.join(",");
                //}
                    //
                let params = {
                    role_id:self.role_id,
                    name: self.current_role.name,
                    display_name: self.current_role.display_name,
                    description: self.current_role.description,
                    permission_idz:permissions,
                    //permissions: permissions
                };

                if (self.selected_property_id) {
                    params.property_id = self.selected_property_id;
                    params.property_permission_ids = (self.property_permission_idz || []).join(",");
                }

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.clearFilter();
                    self.showRolePermissionEdit = false;
                    self.$timeout(function() {
                        $("select.dashboard-select#role-project-select").niceSelect('update');
                        $("select.dashboard-select#copy-property-select").niceSelect('update');
                    });

                    self.SSAlertService.success('Success!', 'Permissions updated successfully.');

                    // Get updated data
                    self.getRolesData(null, true);
                    self.getRolePermission();
                });
            }
        );

    }
    getPropertyLevelPermissions(rolePermissions){
        const self = this;

        let permissions = [];

        if(rolePermissions){
            $.each(rolePermissions, function(index, permission){
                if(permission.property_ids){
                    permissions.push(permission);
                }
            });
        }
        return permissions;
    }

    getDevLevelPermissions(rolePermissions){
        const self = this;

        let permissions = [];

        if(rolePermissions){
            $.each(rolePermissions, function(index, permission){
                if(!permission.property_ids){
                    permissions.push(permission);
                }
            });
        }
        return permissions;
    }
    getParentRoles(roles){
        const self = this;
        self.parentRoles = [];
        $.each(roles, function (i,e) {
            if (!this.parent_role_id) {
                self.parentRoles.push(this);
            }
        });

    }



    toggleSelect(value,key) {
        const self = this;

        var check = $("input[name='"+key+"']").prop('checked');

        $(value).each(function(index, permission){

            // WEB-3085: property-level permissions are tracked separately from
            // permissions_idz — see parentCheked/addRemovePropertyPermission.
            if (permission.property_level) {
                self.setPropertyPermissionChecked(permission.id, check);
            } else {
                self.addRemovePermissions(permission.id,check);
            }
        })

    }


    parentCheked(value) {
        const self = this;

        var counter = 0;
        $(value).each(function(index, permission){
            let isChecked = permission.property_level
                ? (self.property_permission_idz.indexOf(permission.id) > -1)
                : self.findValueInArray(permission.id,self.permissions_idz);
            if(!isChecked)
            {
                counter = 1
            }
        });

        if(counter == 1){
            return false;
        }

        return true;
    }

    toggleChangeset(id) {
        const self = this;

        let div = $("#divChangeset" + self.groupSpacehandle(id));

        if (div.is(":visible")) {
            div.slideUp(400);
        } else {
            div.slideDown(400);
        }
    }
    toggleChangeset2(id) {
        const self = this;

        let div2 = $("#divChangesett" + self.groupSpacehandle(id));

        if (div2.is(":visible")) {
            div2.slideUp(400);
        } else {
            div2.slideDown(400);
        }
    }

    showChangeset(id) {
        const self = this;

        let div = $("#divChangeset" + self.groupSpacehandle(id));

        if (!div.is(":visible")) {
            div.slideDown(400);
        }
    }

    showPartialesetPermission(id,values) {
        const self = this;

        let div = $("#divChangeset" + self.groupSpacehandle(id));
        let counter = 0;

        $(values).each(function(index, permission){
            if(self.findValueInArray(permission.id,self.permissions_idz))
            {
                counter += 1;
            }
        });

        if(counter == values['length'])
        {
            div.slideDown(400);
        }
        else if (counter == 0){

            div.slideDown(400);
        }
        else
            div.slideUp(400);


    }

    findValueInArray(value,arr){
        for(var i=0; i<arr.length; i++){
            var name = arr[i];
            if(name == value){
                return true;
            }
        }
        return false;
    }


    filterPermission(){
        const self = this;
        self.applyMarkerFilter(self.filter_permissions);
    }
    /**
     * Build a CSS-safe DOM-id fragment from a permission-group name.
     *
     * The same fragment is used to (a) render each group panel's `id` attribute
     * in the Blade and (b) build the `$("#divChangeset" + fragment)` jQuery
     * selector in toggleChangeset()/toggleChangeset2(). Group names can contain
     * symbols that are illegal in an unescaped CSS identifier (notably `&`), and
     * passing such a string to Sizzle throws "unrecognized expression". Replacing
     * every non-alphanumeric character with `_` (not just spaces) keeps both
     * sides in sync and guarantees a valid selector.
     *
     * @param {string} id - Raw permission-group name (e.g. "Super Admin — Roles & Permissions").
     * @returns {string} CSS-safe id fragment (e.g. "Super_Admin___Roles___Permissions").
     */
    groupSpacehandle(id)
    {
        return String(id).replace(/[^A-Za-z0-9]/g, '_');
    }
    clearFilter(){
        const self = this;
        self.filter_permissions = '';
        self.filter_marker = '';
        self.applyMarkerFilter();
    }

    filterPermissionsList() {
        const self = this;
        if (!self.response || !self.response.permissions) return;

        const search = (self.filter_list_search || '').toLowerCase().trim();
        const group  = self.filter_list_group  || '';
        const marker = self.filter_list_marker || '';
        const ssOnly = !!self.filter_list_ss_only;

        self.permissions = self.response.permissions.filter(function (p) {
            if (search && (p.name || '').toLowerCase().indexOf(search) === -1
                       && (p.display_name || '').toLowerCase().indexOf(search) === -1) return false;
            if (group  && p.group  !== group)  return false;
            if (marker && p.marker !== marker) return false;
            if (ssOnly && p.is_ss_only != 1)  return false;
            return true;
        });
    }

    clearPermissionsList() {
        const self = this;
        self.filter_list_search  = '';
        self.filter_list_group   = '';
        self.filter_list_marker  = '';
        self.filter_list_ss_only = false;
        if (self.response && self.response.permissions) {
            self.permissions = self.response.permissions;
        }
    }

    /**
     * Derive a role category marker from the role's code/name prefix.
     * Used as fallback when the server has not yet computed a `marker` field on the role.
     *
     * @param {string} roleName
     * @returns {string|null}
     */
    detectRoleMarker(roleName) {
        if (!roleName) return null;
        const name = roleName.toUpperCase();
        if (name.startsWith('SS_') || name.startsWith('SUPER_')) return 'SUPER';
        if (name.startsWith('DEV_'))       return 'DEV';
        if (name.startsWith('AGENCY_'))    return 'AGENCY';
        if (name.startsWith('LAW_FIRM_'))  return 'LAW_FIRM';
        if (name.startsWith('AMP_'))       return 'AMP';
        return null;
    }

    /**
     * Rebuild `grouped_all_permissions_data` from the full permissions list,
     * applying the active marker filter and the auto-derived role marker / SS-only rules.
     *
     * Filter precedence:
     *   1. `filter_marker === '__all__'`  → show everything (override all auto-filters).
     *   2. `filter_marker` set to a specific value → apply that marker filter explicitly.
     *   3. Otherwise ('' / 'Auto') → use `role_marker` and `role_is_ss_only` to auto-filter.
     *
     * Then applies the name search (`nameSearch`) on top.
     *
     * @param {string} [nameSearch='']
     */
    applyMarkerFilter(nameSearch) {
        const self = this;
        if (!self.response || !self.response.permissions) return;

        const search = (nameSearch || '').toLowerCase().trim();
        const showAll = self.filter_marker === '__all__';
        const explicitMarker = (!showAll && self.filter_marker) ? self.filter_marker : null;
        const autoMarker = (!showAll && !explicitMarker) ? self.role_marker : null;
        const hideSsOnly = !showAll && (self.role_is_ss_only != 1);

        self.permissions = self.response.permissions.filter(function (p) {
            if (search && p.name.toLowerCase().indexOf(search) === -1) return false;
            if (!showAll && hideSsOnly && p.is_ss_only == 1) return false;
            const activeMarker = explicitMarker || autoMarker;
            if (activeMarker && p.marker && p.marker !== activeMarker) return false;
            // WEB-3085: property-level permissions are only editable once a
            // Project is selected (next to the Edit button).
            if (p.property_level && !self.selected_property_id) return false;
            return true;
        });

        self.grouped_all_permissions_data = {};
        for (var i in self.permissions) {
            const group = self.permissions[i].group;
            self.grouped_all_permissions_data.hasOwnProperty(group)
                ? self.grouped_all_permissions_data[group].push(self.permissions[i])
                : (self.grouped_all_permissions_data[group] = [self.permissions[i]]);
        }
    }

    /**
     * Returns an ng-style object for a coloured marker badge.
     *
     * @param {string} marker
     * @returns {{background: string, color: string, 'font-size': string}}
     */
    getMarkerBadgeStyle(marker) {
        const colours = {
            SUPER:    '#6f42c1',
            DEV:      '#0077c8',
            AGENCY:   '#fd7e14',
            LAW_FIRM: '#20c997',
            AMP:      '#dc3545',
        };
        return {
            background: colours[marker] || '#6c757d',
            color: '#fff',
            'font-size': '0.75em',
        };
    }

}

SuperPermissionsController.$inject = ['$scope', '$timeout', '$window', 'Upload','SSHttpService', 'SSUtilService', 'SSDateService', 'SSAwsService', 'SSAppService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSConfirmationService', 'OTPService'];
app.controller('SuperPermissionsController', SuperPermissionsController);


